/** The help center (a tinycms site) and the pages the app links to. */
export const HELP_CENTER = 'https://tinycms-help.tinycms.ai';
export const CONTENT_API_DOCS = `${HELP_CENTER}/developers/content-api`;
